import React from "react";
import Flatpickr, { DateTimePickerProps } from "react-flatpickr";

import { CalendarProps } from "./types";

import "flatpickr/dist/themes/airbnb.css";
import "./styles.scss";
import { formatDate, getFlatpickrLocale } from "./utils";

export const DEFAULT_DATE_FORMAT = "MMM DD, YYYY";

export function Calendar(props: CalendarProps) {
  const {
    type = "single",
    showDateInput = false,
    dateFormat = DEFAULT_DATE_FORMAT,
    defaultDate,
    value,
    minDate,
    maxDate,
    customInput,
    onChangeDate,
    disableMobile = false,
    inputPlaceholder,
    locale,
  } = props;
  const [internalSelectedDate, setInternalSelectedDate] = React.useState<Date[] | undefined>(
    defaultDate
  );

  const selectedDate = value !== undefined ? value : internalSelectedDate;

  const handleChange = (dates: Date[]) => {
    if (onChangeDate) onChangeDate(dates);
    if (value === undefined) {
      setInternalSelectedDate(dates);
    }
  };

  const onRenderInput = (
    props: Omit<DateTimePickerProps, "options" | "render">,
    ref: (node: HTMLInputElement) => void
  ) => {
    if (customInput && ref) {
      const renderedCustomInput = customInput({ innerRef: ref, ...props });
      return renderedCustomInput;
    } else {
      if (showDateInput) {
        return (
          <input
            ref={ref}
            className="flatpickr-input"
            placeholder={inputPlaceholder}
          />
        );
      } else {
        return (
          <input
            ref={ref}
            style={{ display: "none" }}
          />
        );
      }
    }
  };

  return (
    <Flatpickr
      className="calendar"
      data-testid="Calendar"
      onChange={handleChange}
      value={selectedDate}
      render={(props, ref) => onRenderInput(props, ref)}
      options={{
        locale: getFlatpickrLocale(locale),
        inline: customInput || showDateInput ? false : true,
        mode: type,
        dateFormat,
        minDate,
        maxDate,
        disableMobile,
        formatDate: (date, format) => {
          return formatDate(type, date, format, selectedDate as Date[], locale);
        },
      }}
    />
  );
}
